export class MinisterialTraining{
    id?: number;
    type: string;
    is_graduated: boolean;
    credits_number: number;
    institution: string;
    minister_id?: number;
    ano_egreso?: number;
    
    constructor()
    {
        this.id = null;
        this.type = null;
        this.is_graduated = false;
        this.credits_number = null;
        this.institution = null;
        this.minister_id = null;
        this.ano_egreso = null;
    }

}


// WEBPACK FOOTER //
// ./src/app/models/MinisterialTraining.model.ts